import { Box, Typography } from '@mui/material';
import React from 'react';
import { CashoutAssetError } from '../../../../types/cashout.types';

function AssetErrorRow({ failure }: { failure: CashoutAssetError }) {
    // Strip internal error codes like "INSUFFICIENT_BALANCE: ..." → show only the human part
    const humanMessage = React.useMemo(() => {
        const colonIdx = failure.error.indexOf(': ');
        if (colonIdx !== -1) {
            const after = failure.error.slice(colonIdx + 2);
            // Only use the part after the colon if it looks like a sentence, not another code
            if (after && !/^[A-Z_]+$/.test(after.trim())) return after;
        }
        return failure.error;
    }, [failure.error]);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                padding: '6px 0',
                borderBottom: '1px solid rgba(255,107,107,0.08)',
                '&:last-child': { borderBottom: 'none', paddingBottom: 0 },
            }}
        >
            <Box
                sx={{
                    minWidth: '52px',
                    backgroundColor: 'rgba(255,107,107,0.15)',
                    borderRadius: '4px',
                    padding: '2px 6px',
                    textAlign: 'center',
                    flexShrink: 0,
                    marginTop: '1px',
                }}
            >
                <Typography sx={{ fontSize: '11px', fontWeight: '700', color: '#FF6B6B', fontFamily: 'Avenir' }}>
                    {failure.asset}
                </Typography>
            </Box>
            <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', fontFamily: 'Avenir', lineHeight: '1.45' }}>
                {humanMessage}
            </Typography>
        </Box>
    );
}

export default AssetErrorRow;